import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface IState extends IDefaultState<any, any, any> {
  entitiesForBillingSelect: any[]
}

const reducers = {
  ...defaultReducers,
  countryFromRegionsFetched: (state:IState, action:PayloadAction) => {
    state.error = null;
    state.actionsLoading = false;
    state.itemsLoading = false;
    state.itemForEdit = { ...state.itemForEdit, countryId: action.payload };
  },
  regionFromCityFetched: (state:IState, action:PayloadAction) => {
    state.error = null;
    state.actionsLoading = false;
    state.itemForEdit = { ...state.itemForEdit, regionId: action.payload };
  },
  setItemsSelectLoading: (state:IState, action:PayloadAction<boolean>) => {
    state.dropDownLoading = action.payload;
  },
  setItemsSelect: (state:IState, action:PayloadAction<any[]>) => {
    state.dropDownItems = action.payload;
  },
  setCitiesForBilling: (state:IState, action:PayloadAction<any[]>) => {
    state.entitiesForBillingSelect = action.payload;
  }
};

const initialState:IState = {
  ...defaultInitialState,
  entitiesForBillingSelect: []
};

export const citiesSlice = createSlice({
  name: "cities",
  initialState,
  reducers,
});
